'use client';

import React, { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

const ReferralProgram: React.FC = () => {
  const [referralCode, setReferralCode] = useState<string>('SEVA2026XYZ');
  const [copied, setCopied] = useState<boolean>(false);

  const handleCopyCode = () => {
    navigator.clipboard.writeText(referralCode);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const shareOptions = [
    { id: 'whatsapp', name: 'WhatsApp', icon: 'ChatBubbleLeftRightIcon', color: 'bg-green-500' },
    { id: 'facebook', name: 'Facebook', icon: 'ShareIcon', color: 'bg-blue-600' },
    { id: 'twitter', name: 'Twitter', icon: 'AtSymbolIcon', color: 'bg-sky-500' },
    { id: 'email', name: 'Email', icon: 'EnvelopeIcon', color: 'bg-gray-600' },
  ];

  return (
    <div className="bg-gradient-to-br from-accent/10 via-primary/10 to-secondary/10 rounded-xl p-6 lg:p-8">
      <div className="text-center mb-6">
        <div className="w-16 h-16 bg-accent/20 rounded-full flex items-center justify-center mx-auto mb-4">
          <Icon name="GiftIcon" size={32} className="text-accent" variant="solid" />
        </div>
        <h3 className="text-2xl font-heading font-bold text-foreground mb-2">
          Spread the Word, Multiply the Impact
        </h3>
        <p className="text-muted-foreground">
          Refer friends and family to join our mission. Every referral strengthens our community.
        </p>
      </div>

      <div className="bg-card rounded-xl p-6 mb-6">
        <div className="flex items-center justify-between mb-4">
          <div>
            <p className="text-sm font-semibold text-foreground mb-1">Your Referral Code</p>
            <p className="text-xs text-muted-foreground">Share this code with your network</p>
          </div>
        </div>

        <div className="flex items-center space-x-3">
          <div className="flex-1 bg-muted rounded-lg px-4 py-3 font-mono text-lg font-bold text-foreground">
            {referralCode}
          </div>
          <button
            onClick={handleCopyCode}
            className="bg-primary text-primary-foreground px-6 py-3 rounded-lg font-heading font-semibold hover:bg-primary/90 transition-all duration-300 shadow-subtle hover:shadow-cta flex items-center space-x-2"
          >
            <Icon name={copied ? 'CheckIcon' : 'ClipboardDocumentIcon'} size={20} />
            <span>{copied ? 'Copied!' : 'Copy'}</span>
          </button>
        </div>
      </div>

      <div className="space-y-4">
        <p className="text-sm font-semibold text-foreground text-center">Share via</p>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
          {shareOptions.map((option) => (
            <button
              key={option.id}
              className={`${option.color} text-white rounded-lg p-4 hover:opacity-90 transition-all duration-300 shadow-subtle hover:shadow-cta flex flex-col items-center space-y-2`}
            >
              <Icon name={option.icon as any} size={24} />
              <span className="text-sm font-semibold">{option.name}</span>
            </button>
          ))}
        </div>
      </div>

      <div className="mt-6 bg-muted rounded-lg p-4">
        <div className="flex items-start space-x-3">
          <Icon name="SparklesIcon" size={20} className="text-accent mt-0.5 flex-shrink-0" />
          <div>
            <p className="text-sm font-semibold text-foreground mb-1">Referral Benefits</p>
            <ul className="text-xs text-muted-foreground space-y-1">
              <li>• Recognition in our monthly newsletter</li>
              <li>• Exclusive volunteer opportunities</li>
              <li>• Community impact reports</li>
              <li>• Special event invitations</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReferralProgram;